import StakeholderViewItem from "./StakeholderViewItem"
import stakeholderItemConnector from "../stakeholder-item-connector"

export default stakeholderItemConnector(StakeholderViewItem)
